export const HTMLCurriculumData = {
  title: 'HTML Fundamentals',
  curriculum: [
    { section: 'Introduction to HTML', topics: ['What is HTML?', 'HTML Document Structure', 'Doctype', 'HTML5 Overview'] },
    { section: 'Basic Tags', topics: ['Headings', 'Paragraphs', 'Links', 'Images', 'Lists', 'Tables'] },
    { section: 'Forms', topics: ['Form Elements', 'Input Types', 'Labels & Fieldsets', 'Validation Attributes'] },
    { section: 'Semantic HTML', topics: ['header, nav, main, section, article, aside, footer', 'Benefits of Semantic HTML'] },
    { section: 'Media', topics: ['Audio & Video', 'Embedding YouTube', 'SVG & Canvas'] },
    { section: 'Meta & SEO', topics: ['Meta Tags', 'Open Graph', 'Accessibility Basics', 'SEO Best Practices'] },
    { section: 'Best Practices', topics: ['Indentation & Formatting', 'Comments', 'Organizing Code', 'Common Pitfalls'] }
  ],
  styles: {
    backgroundGradient: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
    titleGradient: 'linear-gradient(90deg, #f7971e 0%, #ffd200 100%)',
    sectionHeadingColor: '#f7971e',
    textColor: '#222',
    sectionBlockBg: 'rgba(255,255,255,0.15)'
  }
};

export const CSSCurriculumData = {
  title: 'CSS Mastery',
  curriculum: [
    { section: 'Introduction to CSS', topics: ['What is CSS?', 'How CSS Works', 'CSS Syntax', 'Including CSS in HTML'] },
    { section: 'Selectors & Properties', topics: ['Element, Class, ID Selectors', 'Attribute Selectors', 'Pseudo-classes & Pseudo-elements', 'Combinators'] },
    { section: 'Colors, Units & Typography', topics: ['Color Formats', 'Font Properties', 'Units (px, em, rem, %)', 'Responsive Typography'] },
    { section: 'Box Model & Layout', topics: ['Box Model', 'Margin, Border, Padding', 'Display Property', 'Positioning', 'Float & Clear'] },
    { section: 'Flexbox & Grid', topics: ['Flexbox Basics', 'Align & Justify', 'Grid Basics', 'Grid Areas', 'Responsive Layouts'] },
    { section: 'Backgrounds & Borders', topics: ['Background Images', 'Gradients', 'Border Radius', 'Box Shadow'] },
    { section: 'Transitions & Animations', topics: ['CSS Transitions', 'Keyframes', 'Animation Properties', 'Transform'] },
    { section: 'Responsive Design', topics: ['Media Queries', 'Mobile First', 'Breakpoints', 'Viewport Units'] },
    { section: 'Best Practices', topics: ['Organizing CSS', 'Naming Conventions (BEM)', 'Preprocessors (Sass, LESS)', 'Performance Tips'] }
  ],
  styles: {
    backgroundGradient: 'linear-gradient(135deg, #43cea2 0%, #185a9d 100%)',
    titleGradient: 'linear-gradient(90deg, #43cea2 0%, #185a9d 100%)',
    sectionHeadingColor: '#43cea2',
    textColor: '#fff',
    sectionBlockBg: 'rgba(255,255,255,0.05)'
  }
};

export const JavaScriptCurriculumData = {
  title: 'JavaScript',
  curriculum: [
    { section: 'Introduction to JavaScript', topics: ['What is JavaScript?', 'History and Evolution', 'JavaScript in the Browser', 'Hello World Example'] },
    { section: 'Variables & Data Types', topics: ['var, let, const', 'Primitive Types', 'Reference Types', 'Type Conversion'] },
    { section: 'Operators & Expressions', topics: ['Arithmetic Operators', 'Assignment Operators', 'Comparison Operators', 'Logical Operators', 'Ternary Operator'] },
    { section: 'Control Flow', topics: ['if, else, else if', 'switch statement', 'for, while, do...while loops', 'break & continue'] },
    { section: 'Functions', topics: ['Function Declaration', 'Function Expression', 'Arrow Functions', 'Parameters & Arguments', 'Return Values', 'Scope & Closures'] },
    { section: 'Objects & Arrays', topics: ['Object Literals', 'Accessing & Modifying Properties', 'Array Methods', 'Destructuring', 'Spread & Rest Operators'] },
    { section: 'DOM Manipulation', topics: ['Selecting Elements', 'Changing Content & Styles', 'Event Listeners', 'Creating & Removing Elements'] },
    { section: 'ES6+ Features', topics: ['let & const', 'Template Literals', 'Default Parameters', 'Destructuring', 'Arrow Functions', 'Modules'] },
    { section: 'Asynchronous JavaScript', topics: ['Callbacks', 'Promises', 'Async/Await', 'Fetching Data with fetch()'] },
    { section: 'Best Practices & Debugging', topics: ['Linting & Formatting', 'Debugging Tools', 'Writing Clean Code', 'Common Pitfalls'] }
  ],
  styles: {
    backgroundGradient: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
    titleGradient: 'linear-gradient(90deg, #FFD600 0%, #FF9100 100%)',
    sectionHeadingColor: '#FFD600',
    textColor: '#fff',
    sectionBlockBg: 'rgba(255,255,255,0.05)'
  }
};

export const ReactCurriculumData = {
  title: 'React Zero to Hero',
  curriculum: [
    { section: 'Introduction to React', topics: ['What is React?', 'Why use React?', 'React vs. Other Frameworks', 'Setting up the Environment'] },
    { section: 'JSX & Rendering', topics: ['JSX Syntax', 'Rendering Elements', 'Expressions in JSX', 'JSX Best Practices'] },
    { section: 'Components', topics: ['Function Components', 'Class Components', 'Props & PropTypes', 'Component Composition', 'Children & Nesting'] },
    { section: 'State & Lifecycle', topics: ['useState Hook', 'Class State', 'Lifecycle Methods', 'useEffect Hook', 'State Lifting'] },
    { section: 'Event Handling', topics: ['Handling Events in React', 'Synthetic Events', 'Passing Arguments to Handlers'] },
    { section: 'Conditional Rendering & Lists', topics: ['if/else in JSX', 'Ternary Operators', 'Rendering Lists', 'Keys in Lists'] },
    { section: 'Forms', topics: ['Controlled Components', 'Uncontrolled Components', 'Handling Input', 'Form Submission', 'Validation'] },
    { section: 'Hooks', topics: ['useState', 'useEffect', 'useRef', 'useContext', 'Custom Hooks'] },
    { section: 'Context & State Management', topics: ['Context API', 'useReducer', 'Redux Basics', 'Global State Patterns'] },
    { section: 'Routing', topics: ['React Router Basics', 'Route Parameters', 'Navigation', 'Nested Routes'] },
    { section: 'Advanced Topics', topics: ['Code Splitting', 'Error Boundaries', 'Refs & Forwarding', 'Portals', 'Performance Optimization'] },
    { section: 'Testing', topics: ['Jest & React Testing Library', 'Unit Testing Components', 'Mocking & Spies', 'End-to-End Testing'] },
    { section: 'Deployment & Best Practices', topics: ['Build Tools', 'Deployment Strategies', 'Linting & Formatting', 'Accessibility', 'Security Best Practices'] }
  ],
  styles: {
    backgroundGradient: 'linear-gradient(135deg, #232526 0%, #414345 100%)',
    titleGradient: 'linear-gradient(90deg, #00f5ff 0%, #764ba2 100%)',
    sectionHeadingColor: '#00f5ff',
    textColor: '#fff',
    sectionBlockBg: 'rgba(255,255,255,0.05)'
  }
};

export const NodeCurriculumData = {
  title: 'Node.js',
  curriculum: [
    { section: 'Introduction to Node.js', topics: ['What is Node.js?', 'Node.js Architecture', 'V8 Engine', 'Installing Node.js & npm'] },
    { section: 'Core Modules', topics: ['fs (File System)', 'path', 'os', 'events', 'http/https', 'process'] },
    { section: 'npm & Packages', topics: ['What is npm?', 'Installing Packages', 'package.json', 'Semantic Versioning', 'Global vs Local Packages'] },
    { section: 'Asynchronous Programming', topics: ['Callbacks', 'Promises', 'Async/Await', 'Event Loop', 'Timers'] },
    { section: 'Building a Web Server', topics: ['http module', 'Request & Response', 'Routing', 'Serving Static Files'] },
    { section: 'Express.js', topics: ['What is Express?', 'Routing in Express', 'Middleware', 'Serving Static Files', 'Error Handling'] },
    { section: 'Working with Databases', topics: ['Connecting to MongoDB', 'CRUD Operations', 'Mongoose Basics'] },
    { section: 'APIs', topics: ['RESTful APIs', 'Building Endpoints', 'Request Validation', 'Authentication (JWT)', 'Error Handling'] },
    { section: 'Deployment', topics: ['Environment Variables', 'Production Builds', 'Hosting Node Apps', 'Process Managers (PM2)'] }
  ],
  styles: {
    backgroundGradient: 'linear-gradient(135deg, #232526 0%, #485563 100%)',
    titleGradient: 'linear-gradient(90deg, #8fd6ff 0%, #43cea2 100%)',
    sectionHeadingColor: '#43cea2',
    textColor: '#fff',
    sectionBlockBg: 'rgba(255,255,255,0.05)'
  }
};

export const GitCurriculumData = {
  title: 'Git & Version Control',
  curriculum: [
    { section: 'Introduction to Git', topics: ['What is Version Control?', 'What is Git?', 'Installing Git', 'Basic Git Workflow'] },
    { section: 'Git Basics', topics: ['git init', 'git add', 'git commit', 'git status', 'git log'] },
    { section: 'Branching & Merging', topics: ['git branch', 'git checkout', 'git merge', 'Resolving Conflicts', 'git stash'] },
    { section: 'Remote Repositories', topics: ['git remote', 'git push', 'git pull', 'git fetch', 'Cloning Repos'] },
    { section: 'Collaboration', topics: ['Forks & Pull Requests', 'Code Reviews', 'Best Practices for Teams'] },
    { section: 'Advanced Git', topics: ['Rebasing', 'Cherry-pick', 'Reverting', 'Resetting', 'Tagging'] },
    { section: 'GitHub & Hosting', topics: ['GitHub Basics', 'SSH Keys', 'Actions & CI/CD', 'Project Boards', 'Releases'] },
    { section: 'Best Practices', topics: ['Commit Messages', 'Branch Naming', 'Ignoring Files', '.gitignore', 'Backup & Recovery'] }
  ],
  styles: {
    backgroundGradient: 'linear-gradient(135deg, #e96443 0%, #904e95 100%)',
    titleGradient: 'linear-gradient(90deg, #e96443 0%, #904e95 100%)',
    sectionHeadingColor: '#e96443',
    textColor: '#fff',
    sectionBlockBg: 'rgba(255,255,255,0.05)'
  }
};

export const MongoDBCurriculumData = {
  title: 'MongoDB',
  curriculum: [
    { section: 'Introduction to MongoDB', topics: ['What is MongoDB?', 'NoSQL vs SQL', 'Document-Oriented Database', 'Installing MongoDB'] },
    { section: 'CRUD Operations', topics: ['Creating Documents', 'Reading Documents', 'Updating Documents', 'Deleting Documents', 'ObjectId'] },
    { section: 'Data Modeling', topics: ['Collections & Documents', 'Schema Design', 'Embedding vs Referencing', 'Indexes'] },
    { section: 'Aggregation', topics: ['Aggregation Pipeline', 'Stages & Operators', 'Common Use Cases'] },
    { section: 'Mongoose', topics: ['What is Mongoose?', 'Schemas & Models', 'Validation', 'CRUD with Mongoose'] },
    { section: 'Advanced Topics', topics: ['Transactions', 'Change Streams', 'Sharding', 'Replication', 'Backups'] },
    { section: 'Best Practices', topics: ['Performance Tuning', 'Security', 'Data Backup', 'Monitoring', 'Scaling'] }
  ],
  styles: {
    backgroundGradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
    titleGradient: 'linear-gradient(90deg, #11998e 0%, #38ef7d 100%)',
    sectionHeadingColor: '#38ef7d',
    textColor: '#fff',
    sectionBlockBg: 'rgba(255,255,255,0.05)'
  }
};

const summarize = (data) => data.curriculum.map((s) => s.section);

export const FullStackCurriculumData = {
  title: 'Full-Stack Web Development (MERN)',
  curriculum: [
    { section: 'HTML Fundamentals', topics: summarize(HTMLCurriculumData) },
    { section: 'CSS Mastery', topics: summarize(CSSCurriculumData) },
    { section: 'JavaScript', topics: summarize(JavaScriptCurriculumData) },
    { section: 'Git & Version Control', topics: summarize(GitCurriculumData) },
    { section: 'React', topics: summarize(ReactCurriculumData) },
    { section: 'Node.js & Express', topics: summarize(NodeCurriculumData) },
    { section: 'MongoDB', topics: summarize(MongoDBCurriculumData) },
    { section: 'Capstone Project', topics: ['Planning & Architecture', 'Auth & Authorization', 'REST API + React Frontend', 'Testing', 'Deploying to the Cloud', 'Portfolio & Demo Day'] }
  ]
};

export const JavaFullStackCurriculumData = {
  title: 'Java Full-Stack Development',
  curriculum: [
    { section: 'Core Java', topics: ['JDK, JVM & JRE', 'Data Types & Operators', 'Control Flow', 'Strings & Arrays', 'Methods & Recursion'] },
    { section: 'Object-Oriented Programming', topics: ['Classes & Objects', 'Inheritance & Polymorphism', 'Abstraction & Interfaces', 'Encapsulation', 'SOLID Principles'] },
    { section: 'Advanced Java', topics: ['Collections Framework', 'Generics', 'Exception Handling', 'Streams & Lambdas', 'Multithreading & Concurrency'] },
    { section: 'Databases & JDBC', topics: ['SQL Fundamentals', 'MySQL / PostgreSQL', 'JDBC', 'Normalization & Indexing'] },
    { section: 'Spring & Spring Boot', topics: ['Dependency Injection & IoC', 'Spring Boot Starters', 'REST Controllers', 'Validation & Exception Handling', 'Profiles & Configuration'] },
    { section: 'Persistence with JPA', topics: ['Hibernate & JPA', 'Entity Relationships', 'Spring Data Repositories', 'Transactions'] },
    { section: 'Security', topics: ['Spring Security', 'JWT Authentication', 'OAuth2 Basics', 'Role-based Access'] },
    { section: 'Frontend with React', topics: ['HTML, CSS & JavaScript Essentials', 'React Components & Hooks', 'Routing', 'Consuming Spring Boot APIs'] },
    { section: 'Testing & DevOps', topics: ['JUnit & Mockito', 'Maven / Gradle', 'Docker', 'CI/CD Pipelines', 'Deploying to AWS'] },
    { section: 'Microservices & Capstone', topics: ['Microservices Fundamentals', 'Spring Cloud Basics', 'End-to-End Capstone Project'] }
  ]
};

export const DSACurriculumData = {
  title: 'Data Structures & Algorithms',
  curriculum: [
    { section: 'Foundations', topics: ['Time & Space Complexity', 'Big-O Notation', 'Recursion', 'Problem-Solving Patterns'] },
    { section: 'Arrays & Strings', topics: ['Two Pointers', 'Sliding Window', 'Prefix Sums', 'Kadane\'s Algorithm', 'String Manipulation'] },
    { section: 'Hashing', topics: ['Hash Maps & Sets', 'Frequency Counting', 'Collision Handling'] },
    { section: 'Linked Lists', topics: ['Singly & Doubly Linked Lists', 'Fast & Slow Pointers', 'Reversal', 'Merge & Cycle Detection'] },
    { section: 'Stacks & Queues', topics: ['Stack Applications', 'Monotonic Stack', 'Queues & Deques', 'Priority Queues'] },
    { section: 'Searching & Sorting', topics: ['Binary Search & Variants', 'Merge Sort', 'Quick Sort', 'Counting & Radix Sort'] },
    { section: 'Trees', topics: ['Binary Trees & Traversals', 'Binary Search Trees', 'Heaps', 'Tries', 'Segment Trees'] },
    { section: 'Graphs', topics: ['BFS & DFS', 'Topological Sort', 'Shortest Paths (Dijkstra, Bellman-Ford)', 'Minimum Spanning Trees', 'Union-Find'] },
    { section: 'Dynamic Programming', topics: ['Memoization vs Tabulation', '1D & 2D DP', 'Knapsack Patterns', 'DP on Strings', 'DP on Trees'] },
    { section: 'Greedy & Backtracking', topics: ['Greedy Choice Property', 'Interval Problems', 'Permutations & Subsets', 'N-Queens & Sudoku'] },
    { section: 'Interview Preparation', topics: ['Pattern-wise Problem Sets', 'Mock Interviews', 'Company-specific Practice', 'Communicating Your Approach'] }
  ]
};

export const SystemDesignCurriculumData = {
  title: 'System Design',
  curriculum: [
    { section: 'Fundamentals', topics: ['Requirements Gathering', 'Back-of-the-envelope Estimation', 'Latency vs Throughput', 'CAP Theorem'] },
    { section: 'Scaling Basics', topics: ['Vertical vs Horizontal Scaling', 'Load Balancers', 'Stateless Services', 'CDNs'] },
    { section: 'Data Storage', topics: ['SQL vs NoSQL', 'Replication', 'Sharding & Partitioning', 'Consistent Hashing', 'Indexes'] },
    { section: 'Caching', topics: ['Cache Strategies', 'Eviction Policies', 'Redis & Memcached', 'Cache Invalidation'] },
    { section: 'Messaging & Async', topics: ['Message Queues', 'Kafka & Event Streaming', 'Pub/Sub', 'Idempotency & Retries'] },
    { section: 'API & Service Design', topics: ['REST vs gRPC vs GraphQL', 'Rate Limiting', 'API Gateways', 'Microservices vs Monolith'] },
    { section: 'Reliability & Observability', topics: ['Fault Tolerance', 'Circuit Breakers', 'Logging, Metrics & Tracing', 'SLAs, SLOs & SLIs'] },
    { section: 'Low-Level Design', topics: ['OOP & Design Patterns', 'Parking Lot', 'Elevator System', 'Splitwise'] },
    { section: 'Case Studies', topics: ['URL Shortener', 'Chat Application', 'News Feed', 'Video Streaming', 'Ride Sharing'] },
    { section: 'Interview Practice', topics: ['Design Interview Framework', 'Mock Design Rounds', 'Trade-off Discussions'] }
  ]
};

export const AgenticAICurriculumData = {
  title: 'Agentic AI',
  curriculum: [
    { section: 'LLM Foundations', topics: ['How LLMs Work', 'Tokens & Context Windows', 'Choosing a Model', 'Calling LLM APIs'] },
    { section: 'Prompt Engineering', topics: ['System Prompts', 'Few-shot Prompting', 'Structured Outputs (JSON)', 'Reducing Hallucinations'] },
    { section: 'Tool Use', topics: ['Function / Tool Calling', 'Designing Tool Schemas', 'Error Handling in Tools', 'Model Context Protocol (MCP)'] },
    { section: 'Retrieval-Augmented Generation', topics: ['Embeddings', 'Vector Databases', 'Chunking Strategies', 'Hybrid Search & Re-ranking'] },
    { section: 'Building Agents', topics: ['The Agent Loop', 'Planning & Reasoning', 'Memory (Short & Long Term)', 'Guardrails'] },
    { section: 'Multi-Agent Systems', topics: ['Orchestrator & Sub-agents', 'Agent Communication Patterns', 'Frameworks (LangGraph, Agent SDKs)'] },
    { section: 'Evaluation & Safety', topics: ['Evals & Test Sets', 'LLM-as-a-Judge', 'Prompt Injection Defense', 'Human-in-the-Loop'] },
    { section: 'Production', topics: ['Cost & Latency Optimization', 'Prompt Caching', 'Streaming', 'Observability & Tracing', 'Deployment'] },
    { section: 'Capstone', topics: ['Build an Autonomous Research Agent', 'Build a Coding Assistant', 'Demo Day'] }
  ]
};
